<div class="d-count">
  <ng-container>
    <div *ngIf="!gameService.endNowDateDifference && gameService.dateDifference < 365" class="day-count d-count-top">
      {{ gameService.dateDifference ? 'Dag ' + gameService.dateDifference : '' }}
    </div>
    <div
      *ngIf="gameService.endNowDateDifference && gameService.endNowDateDifference < 365 && gameService.endNowDateDifference > 1"
      class="day-count d-count-top"
    >
      {{ gameService.endNowDateDifference ? 'Nog ' + gameService.endNowDateDifference + ' dagen' : '' }}
    </div>
    <div
      *ngIf="gameService.endNowDateDifference && gameService.endNowDateDifference < 365 && gameService.endNowDateDifference === 1"
      class="day-count d-count-top"
    >
      {{ gameService.endNowDateDifference ? 'Nog ' + gameService.endNowDateDifference + ' dag' : '' }}
    </div>
  </ng-container>

  <div class="day-counter">
    <div [ngClass]="gameService.trainWidth === 100 ? 'default-border' : ''" [style]="{ width: gameService.trainWidth + '%' }" class="train">
      <div class="train-img">
        <img
          *ngIf="(gameService.dateDifference % 7 >= 4 || gameService.dateDifference % 7 === 0) && !gameService.endNowDateDifference"
          alt="wagon"
          src="../../../../assets/icons/intercity-wagon.svg"
        />
        <img
          *ngIf="(gameService.dateDifference % 7 >= 6 || gameService.dateDifference % 7 === 0) && !gameService.endNowDateDifference"
          alt="wagon"
          src="../../../../assets/icons/intercity-wagon.svg"
        />
        <img
          *ngIf="
            gameService.endNowDateDifference % 7 <= 2 || (gameService.endNowDateDifference % 7 === 0 && gameService.endNowDateDifference)
          "
          alt="wagon"
          src="../../../../assets/icons/intercity-wagon.svg"
        />
        <img
          *ngIf="
            gameService.endNowDateDifference % 7 <= 1 || (gameService.endNowDateDifference % 7 === 0 && gameService.endNowDateDifference)
          "
          alt="wagon"
          src="../../../../assets/icons/intercity-wagon.svg"
        />
        <img alt="train" src="../../../../assets/icons/intercity.svg" />
      </div>
    </div>
    <div class="days">
      <ng-container *ngFor="let day of gameService.dateRange">
        <div *ngIf="!gameService.endNowDateDifference" [style]="gameService.dateDifference >= day ? { color: 'white' } : ''" class="day">
          <div
            *ngIf="!gameService.endNowDateDifference"
            [style]="gameService.dateDifference === day ? { background: 'white' } : ''"
            class="line"
          ></div>
          <div
            *ngIf="gameService.endNowDateDifference"
            [style]="gameService.endNowDateDifference === day ? { background: 'white' } : ''"
            class="line"
          ></div>
          {{ day < 365 && day > 0 ? day : '-' }}
        </div>

        <div
          *ngIf="gameService.endNowDateDifference"
          [style]="gameService.endNowDateDifference <= day ? { color: 'white' } : ''"
          class="day"
        >
          <div
            *ngIf="!gameService.endNowDateDifference"
            [style]="gameService.dateDifference === day ? { background: 'white' } : ''"
            class="line"
          ></div>
          <div
            *ngIf="gameService.endNowDateDifference"
            [style]="gameService.endNowDateDifference === day ? { background: 'white' } : ''"
            class="line"
          ></div>
          {{ day < 365 && day > 0 ? day : '-' }}
        </div>
      </ng-container>
    </div>
  </div>
</div>
